import { useEffect, useRef } from "react";

// Safariでだけリサイズ時に画像の位置がおかしくなるSafari側バグの対処。
// バグが直ったらこのhookは消す。
const useScrollerAdjuster = () => {
  const slideUpper1 = useRef<HTMLImageElement>(null);
  const slideUpper2 = useRef<HTMLImageElement>(null);
  const slideLower1 = useRef<HTMLImageElement>(null);
  const slideLower2 = useRef<HTMLImageElement>(null);
  useEffect(() => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isNotMobile = !navigator.userAgent.includes("Mobile")
    const isNotTablet = !(navigator.maxTouchPoints && navigator.maxTouchPoints > 1)
    if (isSafari && isNotMobile && isNotTablet) {
      const resetAnimation = () => {
        [slideUpper1.current, slideUpper2.current, slideLower1.current, slideLower2.current].forEach((element) => {
          const animation = element?.getAnimations()[0];
          animation?.cancel();
          animation?.play();
        });
      };
      let resizeTimer: NodeJS.Timeout | null = null;
      window.addEventListener("resize", () => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(resetAnimation, 200);
        return () => {
          if (resizeTimer) clearTimeout(resizeTimer);
        };
      });
    }
  }, []);
  return [slideUpper1, slideUpper2, slideLower1, slideLower2];
};
export default useScrollerAdjuster;
